import { Box, styles } from '@elparking/components'
import styled from 'styled-components'

const RateBox = styled(Box)`
    ${styles.borderColor}
    border-width: 1px;
    border-radius: 5px;
    border-style: solid;
`

export default RateBox
